import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from '../ConfirmationMessage/ConfirmationMsg.css';

const cx = classNames.bind(styles);
/* istanbul ignore next */
function VoucherNumber({ voucherNumber }) {
    return (
        <div>
            <p
                className={`${cx('voucherNumberLabel')} ${dt(['text-normal'])}`}
                data-automation-id="voucherNumber"
            >
                Voucher Number:
            </p>
            <p className={dt(['text-normal'])} data-automation-id="orderId">
                <strong className={`${cx('voucherNumberStrong')} ${dt(['pointer-events-none'])}`}>
                    {voucherNumber}
                </strong>
            </p>
        </div>
    );
}

VoucherNumber.defaultProps = {
    orderId: '',
};

VoucherNumber.propTypes = {
    orderId: PropTypes.string,
};

export default VoucherNumber;
